<template>
  <div>
    <el-row  style="text-align: left;text-decoration: underline; font-style: oblique" 
    v-for="(x, key) in rowData" :key="key">
      <div v-if="detailstr.includes(key)">
        <el-col :span="1">&#8903;</el-col>
        <el-col :span="3" style="font-weight: bold">{{
          headername[key] + ":"
        }}</el-col>
        <el-col :span="20"><div v-html="x"></div></el-col>
        <!-- {{ x }} -->
      </div>
    </el-row>
    <!-- <el-row v-if="rowData[attachment]">
      <a :href="rowData[attachment]">Attachment</a>
    </el-row> -->
   
    <el-row  v-if="rowData.ifuploadfile">
      <div style="text-align:left;padding-top:1rem" v-html="listfilesfromlib" ></div>
    </el-row>

    <el-row class="text-center" v-if="rowData.ifimg">
      <img :src="imgurl" class="rounded" />
    </el-row>
  </div>
</template>
<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  mounted() {

    if (this.rowData.ifimg) {
      // this.imgurl=url + "showimg?id=" + this.rowData._id
      this.imgurl=url + "img/" + this.$store.state.clct+"/"+this.rowData._id+".jpg"
    }

    if (this.rowData.ifuploadfile) {
      this.$axios.get(this.rowData.ifuploadfile+"&listonly=yes")
        .then(r => {
          this.listfilesfromlib=r.data
        })
    }
    // let self = this;
    // fetch(url + "showimg?id=" + this.rowData._id)
    //   .then((res) => {
    //     if (res.status === 404) {
    //       self.imgurl = null;
    //       return;
    //     }
    //     return res.blob();
    //   })
    //   .then((blob) => {
    //     self.imgurl = URL.createObjectURL(blob);
       
    //   });
  },
  data() {
    return {
      listfilesfromlib:null,
      imgurl: null,
      headername: {},
    };
  },
  computed: {
    // attachment() {
    //   let attachment = "";
    //   this.$store.state.currentheader.forEach((obj) => {
    //     if (obj.formatter === "link") {
    //       attachment = obj.name;
    //     }
    //   });
    //   return attachment;
    // },
    detailstr() {
      let detailstr = [];
      let headername = {};
      let self = this;
      this.$store.state.currentheader.forEach((obj) => {
        if (obj.type === "detailstr") {
          detailstr.push(obj.name);
          self.$set(self.headername, obj.name, obj.title);
          //self.headername[obj.name]=obj.title
        }
        // if (obj.formatter === "link") {
        //   self.attachment = obj.name;
        // }
      });
      return detailstr;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/presentation/table/detailrow.vue